export const KEY_PREFIX = 'reduxPersist:'
export const REHYDRATE = 'persist/REHYDRATE'
